exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".EgrnFreeForm_row_2r829{display:-webkit-box;display:-ms-flexbox;display:flex}.EgrnFreeForm_left_18m2e,.EgrnFreeForm_right_1mRQN{-webkit-box-flex:1;-ms-flex:1 0 0px;flex:1 0 0}.EgrnFreeForm_left_18m2e{padding-right:8px}.EgrnFreeForm_right_1mRQN{padding-left:8px}@media (max-width:600px){.EgrnFreeForm_row_2r829{display:block}.EgrnFreeForm_left_18m2e,.EgrnFreeForm_right_1mRQN{padding:0}}", ""]);

// exports
exports.locals = {
	"row": "EgrnFreeForm_row_2r829",
	"left": "EgrnFreeForm_left_18m2e",
	"right": "EgrnFreeForm_right_1mRQN"
};